import React, { FC } from 'react';
import { Button, LinkButton, Modal, ScenarioCard } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import { Scenario } from 'src/api/userScenario/types';
import { ROUTES } from 'src/constants/routes.const';
import useSafePush from 'src/hooks/useSafePush';
import * as S from './styles';

const msgs = defineMessages({
  header: { id: 'homeScreen_miniPlayer_popUp_unlockPremiumScenario' },
  upgradeToPRO: {
    id: 'recommended_activity_card_rationing_logic_main_CTA',
  },
  or: { id: 'recommended_activity_card_rationing_logic_OR_connector' },
  learnDescription: {
    id: 'recommended_activity_card_vocabulary_lesson_unstarted_scenario_description',
  },
  skipScenario: {
    id: 'recommended_activity_card_vocab_premium_scenario_second_CTA',
  },
  freeCTA: { id: 'onboarding_upsell_stay_free_CTA' },
  browseScenarios: { id: 'recommended_activity_card_vocab_noFreeScenarios_second_CTA' },
});

export const LockedScenarioPopup: FC<{
  isOpen: boolean;
  onClose: () => void;
  scenario: Scenario;
  onSkip: () => void;
  skippable: boolean;
}> = ({ isOpen, onClose, scenario, onSkip, skippable }) => {
  const intl = useIntl();
  const { safePush } = useSafePush();

  return (
    <Modal darkCloseIcon handleClose={onClose} shouldCloseOnEsc isOpen={isOpen}>
      <S.ModalContent>
        <S.UpgradeToProWrapper>
          <S.Header>{intl.formatMessage(msgs.header)}</S.Header>
          <ScenarioCard scenario={scenario} onClickDetails={() => safePush(ROUTES.payment.plans)} />
          <LinkButton buttonType="primary" buttonSize="medium" href={ROUTES.payment.plans}>
            {intl.formatMessage(msgs.upgradeToPRO)}
          </LinkButton>
          <S.Text>{intl.formatMessage(msgs.or)}</S.Text>
          {skippable ? (
            <>
              <Button buttonType="secondary" onClick={onSkip}>
                {intl.formatMessage(msgs.skipScenario)}
              </Button>
              <S.Text>{intl.formatMessage(msgs.freeCTA)}</S.Text>
            </>
          ) : (
            <LinkButton href={ROUTES.scenarios.learn} buttonType="secondary">
              {intl.formatMessage(msgs.browseScenarios)}
            </LinkButton>
          )}
        </S.UpgradeToProWrapper>
      </S.ModalContent>
    </Modal>
  );
};
